import {SidebarDeployments as DeploymentsComponent} from '@github-ui/code-view-sidebar/components/SidebarDeployments'
import type {SidebarDeploymentsResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
  maxToShow?: number
}

export function SidebarDeployments({ownerLogin, repoName, maxToShow}: Props) {
  // Intentionally do not pass `environments[]` hints from `sections.deployments`
  // here: the `/_sidebar/about` payload caps that list at 4 env names, so using
  // it as a filter would prevent the server from returning the 5th+ environment
  // and hide the "+ N more" link for repos with many environments.
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'deployments', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/deployments`)
      if (!r.ok) throw new Error(`Sidebar deployments fetch failed (${r.status})`)
      return (await r.json()) as SidebarDeploymentsResponse
    },
  })

  if (!data) return null
  return <DeploymentsComponent {...data} maxToShow={maxToShow} />
}
